/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metric_Needs_Attention_HintInputs */

const en_metric_needs_attention_hint = /** @type {(inputs: Metric_Needs_Attention_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On hold or ready to prepare`)
};

const es_metric_needs_attention_hint = /** @type {(inputs: Metric_Needs_Attention_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En espera o listos para surtir`)
};

/**
* | output |
* | --- |
* | "On hold or ready to prepare" |
*
* @param {Metric_Needs_Attention_HintInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const metric_needs_attention_hint = /** @type {((inputs?: Metric_Needs_Attention_HintInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metric_Needs_Attention_HintInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_metric_needs_attention_hint(inputs)
	return es_metric_needs_attention_hint(inputs)
});